import HistoryIcon from '@material-ui/icons/History';
import { RowMenu } from '@components/RowMenu';
import { RowMenuItem } from '@components/RowMenuItem';
import { ILoading } from '@hooks/useLoading';
import { IMenu } from '@hooks/useMenu';
import useMessage from '@hooks/useMessage';
import { useModalWindow } from '@hooks/useModalWindow';
import { Divider } from '@material-ui/core';
import { IVendedor, EnumVendedorStatus } from '@model/Vendedor';
import { useVendedorService } from '@services/VendedorService';
import { AxiosResponse } from 'axios';
import React from 'react';
import { VendedorEditarModal } from './VendedorEditarModal';

export type VendedorMenuProps = {
    menu: IMenu
    vendedor: IVendedor
    commandLoading: ILoading
    onVendedorAtualizado: (vendedor: AxiosResponse<IVendedor>) => void
}

export function VendedorMenu ({ menu, commandLoading, vendedor, onVendedorAtualizado }: VendedorMenuProps) {
    const message = useMessage();
    const vendedorService = useVendedorService();

    const atividadeModal = useModalWindow();
    const editarModal = useModalWindow();

    const handleAlterarStatus = React.useCallback((status: EnumVendedorStatus) => () => {
        if (!commandLoading.isLoading) {
            commandLoading.start();
            vendedorService.alterarStatus(vendedor.vendedorId, {
                novoStatus: status
            })
            .then(response => {
                message.success(`Usuário ${response.data.status === EnumVendedorStatus.Inativo ? "Inativado" : "Ativado"} com sucesso`);
                onVendedorAtualizado(response);
            })
            .catch(message.showBlobException)
            .finally(commandLoading.stop);
        }
    }, [commandLoading, message, onVendedorAtualizado, vendedor.vendedorId, vendedorService]);

    return (
        <React.Fragment>
            <RowMenu
                menu={menu}
            >
                <RowMenuItem 
                    key={0} 
                    onClick={menu.handleItemClick(editarModal.open)}
                    text="Editar"
                />

                <RowMenuItem 
                    key={1} 
                    onClick={menu.handleItemClick(handleAlterarStatus(vendedor.status === EnumVendedorStatus.Inativo ? EnumVendedorStatus.Ativo : EnumVendedorStatus.Inativo))}
                    text={vendedor.status === EnumVendedorStatus.Inativo ? "Ativar" : "Desativar"}
                />

                <Divider />

                <RowMenuItem 
                    key={2} 
                    onClick={menu.handleItemClick(atividadeModal.open)}
                    text="Atividades"
                    icon={<HistoryIcon />}
                />
            </RowMenu>

            <VendedorEditarModal 
                modal={editarModal}
                vendedor={vendedor}
                onVendedorAtualizado={onVendedorAtualizado}
            />
        </React.Fragment>
    )
}